/* eslint-disable */
/* eslint-disable indent, react/jsx-indent, no-trailing-spaces */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import { closeModalWithAdditionalKeys } from 'Helpers/ModalHelper';
import Dialog from 'Components/UI/Dialog';
import Receipts from 'Components/UI/Receipts/receipts';
import { makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import { DialogContent, DialogTitle, Divider } from '@material-ui/core';
import { combineNames } from 'Helpers/Client';

const baseStyle = makeStyles(theme => ({
  primaryBlue: {
    color: theme.palette.primary.main,
  },
}));

const InvoiceReceiptsModal = () => {
  const classes = baseStyle();

  const { householdResource: hhR, invoiceReceipts, getInvoiceReceipts } = useSimpleHousehold();

  useEffect(getInvoiceReceipts, [hhR]);

  if (!hhR) return null;

  const clientNames = combineNames(
    hhR.attr('primaryClientFirstName'),
    hhR.attr('primaryClientLastName'),
    hhR.attr('spouseClientFirstName'),
    hhR.attr('spouseClientLastName'),
  );

  return (
    <Dialog
      open
      fullWidth
      maxWidth="sm"
      onClose={() => closeModalWithAdditionalKeys(['invoiceId'])}
      showCloseIcon
      scroll="paper"
    >
      <DialogTitle>
        <h5 className={classnames(classes.primaryBlue)}>{`Receipts - ${clientNames}`}</h5>
        <Divider />
      </DialogTitle>
      <DialogContent>
        <Receipts invoices={invoiceReceipts} />
      </DialogContent>
    </Dialog>
  );
};

export default InvoiceReceiptsModal;

InvoiceReceiptsModal.propTypes = {};

InvoiceReceiptsModal.defaultProps = {};
